/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Icon } from 'bold-ui'
import { SubmitButton } from 'components/form'

export interface SearchFooterProps {
  isAbleToBuscar: boolean
  isFilterDefault: boolean
  onResetToDefault?(): void
  onSubmit(event?: React.SyntheticEvent<HTMLFormElement>): void
  loading?: boolean
}

export const SearchFooter = (props: SearchFooterProps) => {
  const { isAbleToBuscar, isFilterDefault, onSubmit, onResetToDefault, loading } = props

  const classes = createStyles()

  return (
    <div css={classes.container}>
      <Button onClick={onResetToDefault} disabled={!isAbleToBuscar || isFilterDefault}>
        <Icon icon='redo' style={classes.icon} />
        Voltar para padrão
      </Button>
      <SubmitButton handleSubmit={onSubmit} loading={loading} data-cy='BuscarCidadaosButton' disabled={!isAbleToBuscar}>
        <Icon icon='zoomOutline' style={classes.icon} />
        Buscar
      </SubmitButton>
    </div>
  )
}

const createStyles = () => ({
  container: css`
    display: flex;
    justify-content: flex-end;
    padding: 1rem 0;
    & > *:not(:last-child) {
      margin-right: 0.75rem;
    }
  `,
  icon: css`
    margin-right: 0.5rem;
  `,
})
